module.exports = __webpack_public_path__ + "media/control_acceso/door_detail-6c2a67e0.png";